import { render, staticRenderFns } from "./DoctorPublicPageStatus.vue?vue&type=template&id=2426a25a&"
import script from "./DoctorPublicPageStatus.vue?vue&type=script&lang=js&"
export * from "./DoctorPublicPageStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports